import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getQueryStringParameters } from 'owa-querystring';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "DevTools" */ './lazyIndex'));

const lazyMountMobxReactDevtools = new LazyAction(lazyModule, m => m.mountMobxReactDevtools);

runAfterInitialRender(() => {
    if (isFeatureEnabled('fwk-devTools') && getQueryStringParameters().devtools) {
        lazyMountMobxReactDevtools.importAndExecute();
    }
});
